import { Box, Button, DialogActions, DialogContent, DialogContentText, InputBase, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useState } from "react";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import moment from 'jalali-moment';
import { config } from './persian-mobile-datepicker-config'
import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";
import { useEffect } from "react";

function Remember(props) {

    const [showPicker, setShowPicker] = useState(false);
    

    const RegisterDateHandle = (selectedDate, events) => {
        let day = selectedDate.date.getDate();
        let month = selectedDate.date.getMonth() + 1;
        let year = selectedDate.date.getFullYear();
        console.log(`${day}-${month}-${year}`, events)
        let tmp = { ...props.rememberState }
        tmp["DueDate"] = `${year}-${month}-${day}`
        props.setRememberState(tmp)



    }

    const setRememberState = (value, key) => {
        let tmp = { ...props.rememberState }
        tmp[key] = value
        props.setRememberState(tmp)
    }

    useEffect(() => {
        console.log("props.rememberState", props.rememberState)
        console.log(moment(props.rememberState.DueDate)._d)
    }, [props.rememberState])


    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", px: 1, color: '#8F8F8F' }}>
            <Box>
                <label className='f-14 text-label'>عنوان</label>
                <Box className="inputs-container flex-1" sx={{ width: "auto", mt: 1 }}>
                    <InputBase value={props.rememberState['Title']} onChange={e => setRememberState(e.target.value, 'Title')} />
                </Box>
            </Box>
            <Box>
                <label className='f-14 text-label'>شرح</label>
                <Box className="inputs-container flex-1" sx={{ width: "auto", mt: 1 }}>
                    <InputBase value={props.rememberState['Description']} onChange={e => setRememberState(e.target.value, 'Description')} />
                </Box>
            </Box>
            <Box >
                <label className='f-14 text-label'>تاریخ</label>
                <Box className="inputs-container flex-1" sx={{ display: 'flex', alignItems: 'center', width: "auto", mt: 1 }}>

                    <div className='flex-1 w-chile-100'>
                        <InputBase className='flex-1' value={props.rememberState.DueDate && moment(props.rememberState.DueDate).format('jYYYY/jMM/jDD')} onClick={() => setShowPicker(true)} placeholder='تاریخ ثبت' />
                        <Picker
                            isOpen={showPicker}
                            config={config}
                            value={props.rememberState.DueDate ? moment(props.rememberState.DueDate)._d : new Date()}
                            initialValue={props.rememberState.DueDate ? moment(props.rememberState.DueDate)._d : new Date()}
                            minDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 1, day: 1 })}
                            maxDate={newDate({ year: parseInt(moment().format("jYYYY")) + 100, month: 12, day: 29 })}
                            onSubmit={RegisterDateHandle}
                            // onChange={RegisterDateHandle}
                            onClose={() => setShowPicker(false)}
                            highlightWeekends
                        />
                    </div>
                    <CalendarIcon />
                </Box>
            </Box>
            <Box>
                <Box sx={{ display: "flex", gap: "3px", alignItems: "center" }}>
                    چند روز قبل یادآوری شود؟
                    <Box className="labelDate" sx={{ width: "50px!important" }}>
                        <InputBase className='f-14' value={props.rememberState['RemindDays']} onChange={e => setRememberState(e.target.value, 'RemindDays')} type="number" sx={{ textAlign: "center!important", border: "solid 1px #b1b1b1", borderRadius: "20px", px: 1 }} />
                    </Box>
                </Box>
            </Box>



            
        </Box>
    );
}

export default Remember;